var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            title: "预销售订单",
            visible: _vm.show,
            size: "90%",
            "before-close": _vm.handleClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                disabled: _vm.type == "查看" || _vm.isRejectTo,
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-card",
                { attrs: { header: "基础信息" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "预销售单据号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.sn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sn", $$v)
                                  },
                                  expression: "form.sn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据状态" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: true,
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.changeSalesType },
                                  model: {
                                    value: _vm.form.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "status", $$v)
                                    },
                                    expression: "form.status",
                                  },
                                },
                                _vm._l(_vm.statusArr, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "车牌号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.plateNumber,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "plateNumber", $$v)
                                  },
                                  expression: "form.plateNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "车架号码" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.vinCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "vinCode", $$v)
                                  },
                                  expression: "form.vinCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "品牌" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.brand,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "brand", $$v)
                                  },
                                  expression: "form.brand",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "大系" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.hugeClass,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "hugeClass", $$v)
                                  },
                                  expression: "form.hugeClass",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "车系" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.carSeries,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "carSeries", $$v)
                                  },
                                  expression: "form.carSeries",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "车辆型号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "model", $$v)
                                  },
                                  expression: "form.model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "年款" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.yearPart,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "yearPart", $$v)
                                  },
                                  expression: "form.yearPart",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "排量" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.displacement,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "displacement", $$v)
                                  },
                                  expression: "form.displacement",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "车辆版本" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.vehicleVersion,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "vehicleVersion", $$v)
                                  },
                                  expression: "form.vehicleVersion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "发动机型号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.engineModel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "engineModel", $$v)
                                  },
                                  expression: "form.engineModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "变速箱型号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动带出",
                                },
                                model: {
                                  value: _vm.form.gearboxModel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "gearboxModel", $$v)
                                  },
                                  expression: "form.gearboxModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "订单明细" } },
                [
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activePaneName,
                        callback: function ($$v) {
                          _vm.activePaneName = $$v
                        },
                        expression: "activePaneName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "配件", name: "mountings" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "justify-content": "flex-end",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addMountingsLine()
                                    },
                                  },
                                },
                                [_vm._v("配件明细")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.showObj.mountings,
                                  expression: "showObj.mountings",
                                },
                              ],
                              ref: "mountingsTable",
                              attrs: {
                                height: "400px",
                                data: _vm.form.mountingsList,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "产品编码",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productCode" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "产品名称",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productName" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "销售类型",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "saleType" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.saleType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "saleType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.saleType",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "数量",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "qty" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "number",
                                                disabled: true,
                                                placeholder: "请填写",
                                              },
                                              model: {
                                                value: scope.row.qty,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "qty",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "scope.row.qty",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "营销价格",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "marketingPrice" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "number",
                                                disabled: true,
                                                placeholder: "请填写",
                                              },
                                              model: {
                                                value: scope.row.marketingPrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "marketingPrice",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "scope.row.marketingPrice",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "客户",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "mountingsList." +
                                                scope.$index +
                                                ".customerName",
                                              rules:
                                                _vm.mountingsList.customerName,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  readonly: "",
                                                  placeholder: "请点击图标选择",
                                                },
                                                model: {
                                                  value: scope.row.customerName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "customerName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.customerName",
                                                },
                                              },
                                              [
                                                _c("el-button", {
                                                  attrs: {
                                                    slot: "append",
                                                    icon: "el-icon-search",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectSoldToParty(
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                  slot: "append",
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "批次号",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "batch" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.batch,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "batch",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.batch",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "单位",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "unit" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.unit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "unit",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.unit",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "OE码",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "oeCode" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.oeCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "oeCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.oeCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "废料底价",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "flotsamPrice" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.flotsamPrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "flotsamPrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.flotsamPrice",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "废料产值",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "propertyValue" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.propertyValue,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "propertyValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.propertyValue",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "说明",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "note" } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "请输入" },
                                              model: {
                                                value: scope.row.note,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "note",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.note",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  fixed: "right",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleMountingsDelete(
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "流程审批" } },
                [
                  _vm.form.status <= 1 || _vm.form.status == null
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "选择流程模板",
                                        prop: "flowPathTemplateId",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { placeholder: "选择模板" },
                                          on: {
                                            change: _vm.getFlowTempInfoList,
                                          },
                                          model: {
                                            value: _vm.form.flowPathTemplateId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "flowPathTemplateId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.flowPathTemplateId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.flowPathOptions,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.templateName,
                                                value: item.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.flowPathNodePersonModels &&
                          _vm.form.flowPathNodePersonModels.length > 0
                            ? _c(
                                "el-table",
                                {
                                  ref: "elTable",
                                  staticStyle: { width: "50%" },
                                  attrs: {
                                    data: _vm.form.flowPathNodePersonModels,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "节点名称",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "nodePersonName",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.nodePersonName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3691834225
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "审批人",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "auto",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "flowPathNodePersonModels." +
                                                      scope.$index +
                                                      ".nodePerson",
                                                    rules:
                                                      _vm
                                                        .flowPathNodePersonModels
                                                        .nodePerson,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        readonly: "",
                                                        placeholder:
                                                          "请点击图标选择",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.nodePerson,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "nodePerson",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.nodePerson",
                                                      },
                                                    },
                                                    [
                                                      scope.row.variable
                                                        ? _c("el-button", {
                                                            attrs: {
                                                              slot: "append",
                                                              icon: "el-icon-search",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectNodePerson(
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                            slot: "append",
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4032877737
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("Flow", {
                    ref: "flow",
                    attrs: {
                      disabled: _vm.type == "查看" || _vm.form.status > 2,
                      "custom-event": true,
                      "flow-id": _vm.form.flowId,
                    },
                    on: {
                      flowLoad: _vm.flowLoad,
                      complete: _vm.onComplete,
                      refresh: _vm.flowRefresh,
                      rejectTo: _vm.flowRejectTo,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { padding: "10px 20px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: [3].includes(_vm.form.status),
                        loading: _vm.loading,
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("form", false)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm.form.id && (_vm.form.status == 1 || !_vm.form.status)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveAndSubmit()
                            },
                          },
                        },
                        [_vm._v("提交审核")]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择审批人",
            visible: _vm.showObj.nodePerson,
            width: "30%",
            "before-close": _vm.nodePersonClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "nodePerson", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入审批人名称" },
                    model: {
                      value: _vm.condition.nodePerson.nodePerson,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.nodePerson, "nodePerson", $$v)
                      },
                      expression: "condition.nodePerson.nodePerson",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getNodePersonDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.nodePerson, border: "", height: "300" },
              on: { "selection-change": _vm.handleNodePersonSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "审批人",
                  align: "left",
                  prop: "nodePerson",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.nodePerson.total,
                  page: _vm.pagination.nodePerson.current,
                  limit: _vm.pagination.nodePerson.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.nodePerson,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.nodePerson, "size", $event)
                  },
                  pagination: _vm.getNodePersonDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.nodePersonClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.nodePersonConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择客户",
            visible: _vm.showObj.soldToParty,
            width: "40%",
            "before-close": _vm.soldToPartyClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "soldToParty", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.condition.soldToParty.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.soldToParty,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.soldToParty.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getSoldToPartyDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.soldToParty,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleSoldToPartySelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户编码",
                  align: "left",
                  prop: "customerApplyNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.soldToParty.total,
                  page: _vm.pagination.soldToParty.current,
                  limit: _vm.pagination.soldToParty.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.soldToParty,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.soldToParty, "size", $event)
                  },
                  pagination: _vm.getSoldToPartyDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.soldToPartyClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.soldToPartyConfirm },
                },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.soldToPartyAllConfirm },
                },
                [_vm._v("批量选择")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品配料",
            visible: _vm.showObj.mountings,
            width: "70%",
            "before-close": _vm.mountingsClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "mountings", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.mountings.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productName", $$v)
                      },
                      expression: "condition.mountings.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.mountings.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productCode", $$v)
                      },
                      expression: "condition.mountings.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入OE" },
                    model: {
                      value: _vm.condition.mountings.oeCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "oeCode", $$v)
                      },
                      expression: "condition.mountings.oeCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入车牌" },
                    model: {
                      value: _vm.condition.mountings.carNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "carNo", $$v)
                      },
                      expression: "condition.mountings.carNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getMountings("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.mountings,
                  expression: "loadingObj.mountings",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.mountings, border: "", height: "300" },
              on: { "selection-change": _vm.handleMountingsChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "OE",
                  align: "left",
                  prop: "oeCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车辆ID",
                  align: "left",
                  prop: "carId",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  prop: "carNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  align: "left",
                  prop: "brand",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车系",
                  align: "left",
                  prop: "series",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "年款",
                  align: "left",
                  prop: "modelYear",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发动机型号",
                  align: "left",
                  prop: "engineModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "变速箱型号",
                  align: "left",
                  prop: "transmissionModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排量",
                  align: "left",
                  prop: "displacement",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.mountings.total,
                  page: _vm.pagination.mountings.current,
                  limit: _vm.pagination.mountings.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "size", $event)
                  },
                  pagination: _vm.getMountings,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.mountingsClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.mountingsConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }